// removed by extract-text-webpack-plugin
module.exports = {"theme":"#6cadff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 71